import ErrorDisplay from '../../../components/ErrorDisplay';
import LessonsView from './LessonsView';
import Loading from '../../../components/Loading';
import { Client, Lesson, LessonStudent } from '@opanuj/shared/types';
import { setDocumentTitle } from '../../../utils/documentTitle';
import { useClients } from '../../../hooks/useClients';
import { useEffect } from 'react';
import { useLessonsList } from '../../../hooks/useLessons';

export interface LessonWithClient extends Lesson {
	students: (LessonStudent & {
		client: Client;
	})[];
}

const LessonsController = () => {
	useEffect(setDocumentTitle('Lekcje')); // eslint-disable-line react-hooks/exhaustive-deps
	
	const [lessons, loadingLessons, lessonsError] = useLessonsList()
	const [clients, loadingClients, clientsError] = useClients()
	
	if (loadingLessons || loadingClients) {
		return <Loading/>;
	}
	if (lessonsError || clientsError) {
		return <ErrorDisplay error={lessonsError || clientsError}/>
	}
	const lessonWithClients = lessons!.map((lesson) => {
		return {
			...lesson,
			students: lesson.students.map(({ clientId, ...student }) => {
			    return {
				...student,
				clientId,
				client: clients![clientId!],
			};
			}),
		};
	})
	return <LessonsView lessons={lessonWithClients} />;
}
export default LessonsController;